import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import E from '../ui_core/E';
import Urls from '../urls/Urls';
import './SalesForceWelcomePage.css';
export default class SalesForceWelcomePage {
	constructor({showHouseGrid, configuration}){
		this._setVisible = this._setVisible.bind(this);
		this.show = this.show.bind(this);
		this._element = E.div('sales-force-welcome-page');
		const developerIcon = E.img('developer-icon');
		developerIcon.addEventListener('load', ()=>{this._element.classList.add('developer-icon-loaded');});
		//const siteIcon = E.img('site-icon');
		//siteIcon.addEventListener('load', ()=>{this._element.classList.add('site-icon-loaded');});
		//siteIcon.src = Urls.siteIcon;
		developerIcon.src = Urls.developerIcon;
		const buttonToSitePlan = E.button('button-site-plan');
		const buttonToHouseGrid = E.button('button-house-grid');
		const welcomeToElement = E.div('welcome-to');
		welcomeToElement.textContent=`Welcome to ${configuration.siteName}`;
		/*const siteNameElement = E.div('site-name');
		siteNameElement.textContent=;*/
		//buttonToSitePlan.textContent='Site Plan';
		buttonToSitePlan.textContent='Tap to Explore';
		this._element.addEventListener('click', ()=>{
			this._setVisible(false);
		});
		/*buttonToHouseGrid.addEventListener('click', ()=>{
			this._setVisible(false);
			showHouseGrid();
		});*/
		this._element.appendChild(developerIcon);
		//this._element.appendChild(siteIcon);
		//this._element.appendChild(buttonToSitePlan);
		this._element.appendChild(welcomeToElement);
		//this._element.appendChild(siteNameElement);
		this._element.appendChild(buttonToSitePlan);
		this._setVisible(true);
	}
	_setVisible(value){
		if(value)
			this._element.classList.add('visible');
		else
			this._element.classList.remove('visible');
	}
	show(){
		this._setVisible(true);
	}
	get element(){
		return this._element;
	}
}
